import QRCode from "qrcode";
import { imgUrl } from "@/lib/api";

const W = 1080, H = 1920;
const GREEN = "#1E4D3B", GOLD = "#F59E0B", TERRA = "#C2410C", CREAM = "#FAF7F2", INK = "#291E18";
const FONT = '"Plus Jakarta Sans", system-ui, sans-serif';

const loadImg = (src) => new Promise((resolve) => {
  if (!src) return resolve(null);
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = () => resolve(img);
  img.onerror = () => resolve(null);
  img.src = src;
});

const rounded = (ctx, x, y, w, h, r) => { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); };

const strip = (ctx, y) => {
  const cols = [GOLD, TERRA, CREAM, GOLD];
  for (let x = 0, i = 0; x < W; x += 36, i++) {
    ctx.fillStyle = cols[i % 4];
    ctx.beginPath(); ctx.moveTo(x, y + 24); ctx.lineTo(x + 18, y); ctx.lineTo(x + 36, y + 24); ctx.fill();
  }
};

const wrap = (ctx, text, maxW, maxLines) => {
  const words = text.split(/\s+/), lines = [];
  let line = "";
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxW && line) { lines.push(line); line = w; } else line = test;
  }
  if (line) lines.push(line);
  if (lines.length > maxLines) { lines.length = maxLines; lines[maxLines - 1] = `${lines[maxLines - 1].replace(/\s+\S*$/, "")}…`; }
  return lines;
};

const cover = (ctx, img, x, y, w, h) => {
  const s = Math.max(w / img.width, h / img.height), sw = w / s, sh = h / s;
  ctx.drawImage(img, (img.width - sw) / 2, (img.height - sh) / 2, sw, sh, x, y, w, h);
};

// texts: { label, help, place, price, scan, catName }
export async function makeStatusCard(post, url, texts) {
  await document.fonts?.ready;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  const isReq = post.type === "request";
  ctx.fillStyle = GREEN; ctx.fillRect(0, 0, W, H);
  strip(ctx, 0); strip(ctx, H - 24);

  const logo = await loadImg("/icon-192.png");
  if (logo) ctx.drawImage(logo, 60, 70, 84, 84);
  ctx.fillStyle = GOLD; ctx.font = `800 60px ${FONT}`; ctx.textBaseline = "middle";
  ctx.fillText("Diaspomark", 164, 114);

  const px = 60, py = 200, pw = 960, ph = 860;
  const photo = !isReq && post.photos?.[0] ? await loadImg(imgUrl(post.photos[0])) : null;
  ctx.save(); rounded(ctx, px, py, pw, ph, 48); ctx.clip();
  if (photo) cover(ctx, photo, px, py, pw, ph);
  else {
    ctx.fillStyle = isReq ? "#FFF4EA" : "#F3EDE4"; ctx.fillRect(px, py, pw, ph);
    ctx.fillStyle = TERRA; ctx.font = `800 520px Georgia, serif`; ctx.textAlign = "center";
    ctx.fillText(isReq ? "“" : "D", W / 2, py + ph / 2 + (isReq ? 140 : 20));
    ctx.font = `800 56px ${FONT}`; ctx.fillStyle = isReq ? "#9A3412" : GREEN;
    ctx.fillText(isReq ? texts.help : texts.catName, W / 2, py + ph - 110); ctx.textAlign = "left";
  }
  ctx.restore();

  ctx.font = `800 40px ${FONT}`;
  const lw = ctx.measureText(texts.label).width + 56;
  rounded(ctx, px + 28, py + 28, lw, 72, 36); ctx.fillStyle = isReq ? TERRA : GOLD; ctx.fill();
  ctx.fillStyle = isReq ? "#fff" : INK; ctx.fillText(texts.label, px + 56, py + 66);

  let y = py + ph + 90;
  ctx.fillStyle = "#fff"; ctx.font = `800 76px ${FONT}`; ctx.textBaseline = "alphabetic";
  for (const l of wrap(ctx, post.title, 960, 2)) { ctx.fillText(l, 60, y); y += 92; }
  if (texts.price) { ctx.fillStyle = GOLD; ctx.font = `800 80px ${FONT}`; ctx.fillText(texts.price, 60, y + 10); y += 100; }
  ctx.fillStyle = "rgba(255,255,255,0.85)"; ctx.font = `600 42px ${FONT}`;
  ctx.fillText(wrap(ctx, texts.place, 960, 1)[0] || "", 60, y + 10);

  const cy = 1560, ch = 300;
  rounded(ctx, 60, cy, 960, ch, 40); ctx.fillStyle = CREAM; ctx.fill();
  const qr = await loadImg(await QRCode.toDataURL(url, { margin: 1, width: 240, color: { dark: GREEN, light: CREAM }, errorCorrectionLevel: "M" }));
  if (qr) ctx.drawImage(qr, 90, cy + 30, 240, 240);
  ctx.fillStyle = INK; ctx.font = `800 52px ${FONT}`;
  for (const [i, l] of wrap(ctx, texts.scan, 620, 2).entries()) ctx.fillText(l, 370, cy + 110 + i * 62);
  ctx.fillStyle = "#92400E"; ctx.font = `800 46px ${FONT}`;
  ctx.fillText(wrap(ctx, url.replace(/^https?:\/\//, "").replace(/\/.*$/, ""), 620, 1)[0] || "", 370, cy + 250);

  return new Promise((resolve) => c.toBlob(resolve, "image/png"));
}
